// src/api/interceptors/request.interceptor.ts

/**
 * Request Interceptor
 *
 * WHY: Modify outgoing requests consistently
 * WHAT: Adds auth tokens, request IDs, logging
 * BENEFIT:
 *   - Automatic auth header attachment
 *   - Request tracing with IDs
 *   - Request timing for performance monitoring
 */

// src/api/interceptors/request.interceptor.ts
/**
 * Request Interceptor
 *
 * WHY: Modify outgoing requests consistently
 * WHAT: Adds auth tokens, request IDs, logging
 * BENEFIT:
 *   - Automatic auth header attachment
 *   - Request tracing with IDs
 *   - Request timing for performance monitoring
 */
import type { InternalAxiosRequestConfig } from "axios";
// import { errorLogger } from "../../errors/utils";
import { errorLogger } from "@/core/errors/utils";
// import { errorReporter } from "../../errors/monitoring";
import { errorReporter } from "@/core/errors/monitoring";

/**
 * Storage key for auth token
 * TODO: Replace with your auth storage implementation
 */

/**
 * Get stored auth token
 */

/**
 * Generate unique request ID
 */
const generateRequestId = (): string => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

/**
 * Request interceptor
 * Runs before each request is sent
 */
export const requestInterceptor = (
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig => {
  // Generate and attach request ID
  const requestId = generateRequestId();
  config.headers.set("X-Request-ID", requestId);

  //   // Attach auth token if available
  //   const token = getAuthToken();
  //   if (token) {
  //     config.headers.set("Authorization", `Bearer ${token}`);
  //   }
  config.withCredentials = true;

  // Store start time for duration logging
  (config as unknown as Record<string, unknown>).__startTime = Date.now();

  // Log request (debug level)
  errorLogger.debug(`→ ${config.method?.toUpperCase()} ${config.url}`, {
    requestId,
    params: config.params,
  });

  // Add breadcrumb for error tracking
  errorReporter.addBreadcrumb({
    category: "http",
    message: `${config.method?.toUpperCase()} ${config.url}`,
    level: "info",
    data: { requestId },
  });

  return config;
};

/**
 * Request error interceptor
 * Runs if request setup fails
 */
export const requestErrorInterceptor = (error: unknown): Promise<never> => {
  errorLogger.error("Request setup failed", error);
  return Promise.reject(error);
};
